module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": ("/administracao/contratos/procedimentos/novo/" + (_vm.$route.params.contrato_id))
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar Procedimento")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('cabecario-contrato', {
    attrs: {
      "contratoId": _vm.$route.params.contrato_id
    }
  }), _vm._v(" "), _c('filtro-contrato-procedimento', {
    on: {
      "filtrar": function (filtros) {
        _vm.filtrar(filtros);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                                                Procedimento\n                                                "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('procedimentos.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'procedimentos.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Tipo de Limite")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Limite Físico")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Valor Total")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.valor, 2, ",", ".")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipo_limite")(item.tipo_limite)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tipo_limite > 0 ? "Não Possui" : item.quantidade))]), _vm._v(" "), _c('td', [(item.tipo_limite == 0) ? _c('span', [_vm._v(_vm._s(_vm._f("numberFormat")((item.quantidade * item.valor), 2, ",", ".")))]) : _vm._e(), _vm._v(" "), (item.tipo_limite == 1) ? _c('span', [_vm._v("No Subgrupo")]) : _vm._e(), _vm._v(" "), (item.tipo_limite == 2) ? _c('span', [_vm._v("Não Possui")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/contratos/procedimentos/atualizacao/" + (item.id)),
        "title": " Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Excluir"
      },
      on: {
        "click": function($event) {
          _vm.deletar(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-close",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Procedimentos do Contrato")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-54cd2423"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/contratos/contratoProcedimento.vue
// module id = 850
// module chunks = 0